interface Props {
  fillColor?: string;
}

export default function CartInterestSVG({ fillColor = '#F2AC13' }: Props) {
  return (
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.1" cx="18" cy="18" r="18" fill="#F2AC13" />
      <path
        d="M25.7084 15.6241C23.7834 12.5991 20.9667 10.8574 18 10.8574C16.5167 10.8574 15.075 11.2908 13.7584 12.0991C12.4417 12.9158 11.2584 14.1074 10.2917 15.6241C9.45835 16.9324 9.45835 19.0574 10.2917 20.3658C12.2167 23.3991 15.0334 25.1324 18 25.1324C19.4834 25.1324 20.925 24.6991 22.2417 23.8908C23.5584 23.0741 24.7417 21.8824 25.7084 20.3658C26.5417 19.0658 26.5417 16.9324 25.7084 15.6241ZM18 21.3658C16.1334 21.3658 14.6334 19.8574 14.6334 17.9991C14.6334 16.1408 16.1334 14.6324 18 14.6324C19.8667 14.6324 21.3667 16.1408 21.3667 17.9991C21.3667 19.8574 19.8667 21.3658 18 21.3658Z"
        fill={fillColor}
      />
      <path
        d="M18 15.6172C16.6917 15.6172 15.625 16.6839 15.625 18.0005C15.625 19.3089 16.6917 20.3755 18 20.3755C19.3083 20.3755 20.3833 19.3089 20.3833 18.0005C20.3833 16.6922 19.3083 15.6172 18 15.6172Z"
        fill={fillColor}
      />
    </svg>
  );
}